import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import CloseXsmall from '@elliemae/ds-icons/CloseXsmall';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSInputMask from '@elliemae/ds-form/InputMask';
import DSInput from '@elliemae/ds-form/Input';
import { Pill } from './Pill.js';
import '@babel/runtime/helpers/esm/defineProperty';
import 'react-desc';

var StyledInputPill = aggregatedClasses(Pill)('input-pill', null, function (_ref) {
  var value = _ref.value;
  return {
    value: value
  };
});
function InputPill(_ref2) {
  var _ref2$containerProps = _ref2.containerProps,
      containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? 'Enter Value' : _ref2$placeholder,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      onRemove = _ref2.onRemove,
      value = _ref2.value,
      type = _ref2.type,
      otherProps = _objectWithoutProperties(_ref2, ["containerProps", "placeholder", "onChange", "onRemove", "value", "type"]);

  var TypeOfInput = DSInput; // TODO: implement the DSTimeInput, see how because it returns a moment()
  // TODO: implement the DSDateInput

  switch (type) {
    case 'inputText':
      TypeOfInput = DSInput;
      break;

    case 'inputMask':
      TypeOfInput = DSInputMask;
      break;
  }

  return /*#__PURE__*/React.createElement(StyledInputPill, {
    className: "input-pill",
    classProps: {
      value: value
    },
    containerProps: containerProps,
    label: /*#__PURE__*/React.createElement(TypeOfInput, _extends({
      onChange: onChange,
      placeholder: placeholder,
      value: value
    }, otherProps)),
    rightAddon: value && /*#__PURE__*/React.createElement(CloseXsmall, {
      className: "remove-pill-button",
      onClick: onRemove
    }),
    tabIndex: -1
  });
}

export { InputPill };
//# sourceMappingURL=InputPill.js.map
